import { useCallback, useMemo } from 'react'
import { useHistory } from 'react-router-dom'

import { Breadcrumbs, EmptyState, Layout, Text } from '@loadsmart/loadsmart-ui'
import { Stack } from '@loadsmart/miranda-react'

import IllustrationDepartingTruck from 'core/ui/assets/illustration-departing-truck.svg'

const SHIPPER_LOADS_URL = `/shipments/shipper-loads`

export function EmptyShipmentPageState() {
  const history = useHistory()

  const handleBackToShipperLoads = useCallback(() => {
    history.push(SHIPPER_LOADS_URL)
  }, [history])

  const breadcrumbEntries = useMemo(
    () => [
      {
        label: 'Shipper Loads',
        url: `#${SHIPPER_LOADS_URL}`,
      },
    ],
    []
  )

  return (
    <Stack>
      <Breadcrumbs onBack={handleBackToShipperLoads} entries={breadcrumbEntries} />
      <Layout.Stack space="m" align="center">
        <EmptyState
          illustration={IllustrationDepartingTruck}
          title="Oops! Nothing here."
          description="Looks like the page you're looking for does not exist or is not available anymore."
          variant="page"
        />
        <Text variant="body-bold">
          Go to our carrier platform and find spot loads to keep your truck full
        </Text>
      </Layout.Stack>
    </Stack>
  )
}
